
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.249 21a1.267 1.267 0 01-1.25-1.283V12.75h-1.5a.75.75 0 010-1.5h1.5V3.518a1.236 1.236 0 01.353-.883 1.25 1.25 0 01.883-.385h1.014a.75.75 0 010 1.5h-.75V19.5h.75a.75.75 0 010 1.5h-1zM19.499 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M15.75 9.75a.753.753 0 01-.725-.943 4.776 4.776 0 014.445-3.556h.06a4.774 4.774 0 014.444 3.556.752.752 0 01-.725.943H15.75zm6.359-1.5A3.256 3.256 0 0019.5 6.751a3.256 3.256 0 00-2.61 1.499h5.219zM19.499 20.25c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M15.749 24a.752.752 0 01-.724-.944A4.775 4.775 0 0119.47 19.5l.03-.001.033.001a4.773 4.773 0 014.442 3.556.752.752 0 01-.726.944h-7.5zm6.36-1.5a3.257 3.257 0 00-2.61-1.499 3.256 3.256 0 00-2.61 1.499h5.22zM5.249 12.75c-2.068 0-3.75-1.682-3.75-3.75s1.682-3.75 3.75-3.75S8.999 6.932 8.999 9s-1.683 3.75-3.75 3.75zm0-6c-1.241 0-2.25 1.009-2.25 2.25s1.009 2.25 2.25 2.25 2.25-1.009 2.25-2.25-1.01-2.25-2.25-2.25z"}}),_c('path',{attrs:{"d":"M.749 18.75a.748.748 0 01-.75-.75c0-1.403.547-2.721 1.539-3.712a5.213 5.213 0 013.711-1.536 5.257 5.257 0 015.25 5.249.751.751 0 01-.75.75h-9zm8.174-1.5c-.353-1.71-1.893-2.998-3.673-2.999l-.001-.375v.375c-1.001 0-1.943.39-2.651 1.097a3.697 3.697 0 00-1.025 1.901h7.35z"}})])
          )
        }
      }
    